import React from "react";
import { useTranslation } from "react-i18next";
import AppModal from "components/ui/AppModal";
import AppButton from "components/ui/AppButton";
import GroupModiferTable from "./GroupModiferTable";
import CreateGroupModifier from "features/Modifier/CreateGroup";

const AttachGroupModifierModal = ({
  open,
  onClose = () => {},
  setModal = () => {},
  title = "Attach Customization",
  subtitle = "Attach Customization to the item",
  attachButtonText = "Attach Customizations",
  addNewCustomizationButtonText = "Add New Customization",
  customizations,
  checkedRows,
  toBeUnLinkCustomizations = [],
  setToBeUnLinkCustomizations = () => {},
  toBeAttachedCustomizations = [],
  setToBeAttachedCustomizations = () => {},
  onAddNewCustomizationSuccess = () => {},
}) => {
  const { t } = useTranslation();

  const [selectedCustomizations, setSelectedCustomizations] = React.useState(
    []
  );
  const [openAddNewCustomizationModal, setOpenAddNewCustomizationModal] =
    React.useState(false);

  const handleClose = () => {
    setSelectedCustomizations([]);
    onClose();
  };
  const handleAttachCustomizations = () => {
    setToBeAttachedCustomizations(selectedCustomizations);
    handleClose();
  };
  React.useEffect(() => {
    if (checkedRows?.length > 0) {
      setSelectedCustomizations(checkedRows);
    }
  }, [checkedRows]);

  return (
    <>
      <AppModal
        title={title}
        open={open}
        onClose={handleClose}
        footer={
          <div className="flex justify-end gap-3">
            <AppButton
              size="sm"
              variant="primaryOutline"
              onClick={() => {
                setOpenAddNewCustomizationModal(true);
                setModal(false);
              }}
            >
              {t(addNewCustomizationButtonText)}
            </AppButton>
            <AppButton
              size="sm"
              disabled={selectedCustomizations?.length <= 0}
              variant="primary"
              onClick={() => handleAttachCustomizations()}
            >
              {t(attachButtonText)}
            </AppButton>
          </div>
        }
      >
        <GroupModiferTable
          customizations={customizations}
          selectedCustomizations={selectedCustomizations}
          setSelectedCustomizations={setSelectedCustomizations}
          // setData={setData}
          // setViewGroup={setViewGroup}
          showAttachButton={true}
          showActionButton={false}
          toBeAttachedCustomizations={toBeAttachedCustomizations}
          toBeUnLinkCustomizations={toBeUnLinkCustomizations}
          setToBeUnLinkCustomizations={setToBeUnLinkCustomizations}
        />
      </AppModal>
      <CreateGroupModifier
        open={openAddNewCustomizationModal}
        as="modal"
        title={t("Add New Customization")}
        onClose={() => {
          setOpenAddNewCustomizationModal(false);
          setModal(true);
        }}
        onSuccess={(newCustomization) => {
          onAddNewCustomizationSuccess(newCustomization?.data || newCustomization);
          setOpenAddNewCustomizationModal(false);
          setModal(true);
        }}
      />
    </>
  );
};

export default AttachGroupModifierModal;
